import React, { useState, useRef, useEffect } from 'react'
import {
   Button, Grow, Paper, Popper, ClickAwayListener, MenuList, MenuItem
} from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress';
import dayjs from 'dayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'


export default function FilterDropdownProjects({ selectedSubItems, setSelectedSubItems, coordinatorAll, setCoordinatorAll, coordinatorId, setCoordinatorId, partnersAll, setPartnersAll, partnersId, setPartnersId, financedAll, setFinancedAll, financedId, setFinancedId, visibilityFilter, setVisibilityFilter, handleSubItem, cleanListItem, getAllProjectsWithoutPagination, projects, setProjects, projectsStatus, setProjectsStatus, projectsId, setProjectsId, dateFrom, setDateFrom, dateTo, setDateTo, makeRequest, setMakeRequest, resetAll, handleActiveFilters, activeFilters }) {
   const [mainOpen, setMainOpen] = useState(false)
   const [activeSubMenu, setActiveSubMenu] = useState(null)
   const [items, setItems] = useState([])
   const [subMenuReady, setSubMenuReady] = useState(false)

   const anchorRef = useRef(null)
   const subAnchorRef = useRef(null)

   //додатковий реф на пейпері суб меню,щоб лапати клік
   const subMenuPaperRef = useRef(null);


   //юзефект для обробки масиву айтемів

   useEffect(() => {
      const result = [

         {
            key: 'Visibility',
            label: 'Visibility',
            slug: 'Visibility',
            options: [
               { id: 'visible', name: 'Visible', slug: 'Visibility' },
               { id: 'non_visible', name: 'Hidden', slug: 'Visibility' }
            ]
         },
         //вставка prolect id
         {
            key: 'Projects',
            label: `Id's`,
            slug: 'Projects',
            options: [...projects]
         },
         //вставка prolect id(верх)

         {
            key: 'Status',
            label: 'Status',
            slug: 'Status',
            options: [
               {
                  id: 'Completed',
                  name: 'Completed',
                  slug: 'Completed',
                  icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                     <g clipPath="url(#clip0_2001_6752)">
                        <path d="M18.3337 9.23355V10.0002C18.3326 11.7972 17.7507 13.5458 16.6748 14.9851C15.5988 16.4244 14.0864 17.4773 12.3631 17.9868C10.6399 18.4963 8.79804 18.4351 7.11238 17.8124C5.42673 17.1896 3.98754 16.0386 3.00946 14.5311C2.03138 13.0236 1.56682 11.2403 1.68506 9.44714C1.80329 7.65402 2.498 5.94715 3.66556 4.58111C4.83312 3.21506 6.41098 2.26303 8.16382 1.867C9.91665 1.47097 11.7505 1.65216 13.392 2.38355M18.3337 3.33355L10.0003 11.6752L7.50033 9.17521" stroke="#434349" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                     </g>
                     <defs>
                        <clipPath id="clip0_2001_6752">
                           <rect width="20" height="20" fill="white" />
                        </clipPath>
                     </defs>
                  </svg>
               },
               {
                  id: 'Pending',
                  name: 'Pending',
                  slug: 'Pending',
                  icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                     <g clipPath="url(#clip0_2001_9098)">
                        <path d="M10.0003 4.99984V9.99984L13.3337 11.6665M18.3337 9.99984C18.3337 14.6022 14.6027 18.3332 10.0003 18.3332C5.39795 18.3332 1.66699 14.6022 1.66699 9.99984C1.66699 5.39746 5.39795 1.6665 10.0003 1.6665C14.6027 1.6665 18.3337 5.39746 18.3337 9.99984Z" stroke="#434349" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                     </g>
                     <defs>
                        <clipPath id="clip0_2001_9098">
                           <rect width="20" height="20" fill="white" />
                        </clipPath>
                     </defs>
                  </svg>
               },
               {
                  id: 'Planned',
                  name: 'Planned',
                  slug: 'Planned',
                  icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                     <g clipPath="url(#clip0_2001_8649)">
                        <path d="M10.0003 18.3332C14.6027 18.3332 18.3337 14.6022 18.3337 9.99984C18.3337 5.39746 14.6027 1.6665 10.0003 1.6665C5.39795 1.6665 1.66699 5.39746 1.66699 9.99984C1.66699 14.6022 5.39795 18.3332 10.0003 18.3332Z" stroke="#434349" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                     </g>
                     <defs>
                        <clipPath id="clip0_2001_8649">
                           <rect width="20" height="20" fill="white" />
                        </clipPath>
                     </defs>
                  </svg>
               }
            ]
         },
         {
            key: 'Financed',
            label: 'Financed',
            slug: 'Financed',
            options: [...financedAll]
         },
         {
            key: 'Partners',
            label: 'Partners',
            slug: 'Partners',
            options: [...partnersAll]
         },
         {
            key: 'Coordinator',
            label: 'Coordinator',
            slug: 'Coordinator',
            options: [...coordinatorAll]
         },
         {
            key: 'Date_of_start',
            label: 'Start date',
            slug: 'Date_of_start',
            // options: [...coordinatorAll]
         },


      ];


      setItems(result);
   }, [selectedSubItems]);
   ///юзефект для обробки масиву айтемів(верх)



   useEffect(() => {
      if (!mainOpen) {
         //стани які необхідно скидати для очищення,setMakeRequest потрібен для дат і запиту після очищення
         // setSelectedSubItems([])
         // setVisibilityFilter(undefined)
         // setProjectsStatus('')
         // setProjectsId(null)
         // setCoordinatorId(null)
         // setFinancedId(null)
         // setPartnersId(null)
         //скидання дат
         // setDateFrom(null)
         // setDateTo(null)
         // setMakeRequest(true)
      } else {
         // setMakeRequest(false)
      }

   }, [mainOpen])

   const handleToggleMain = () => {
      setMainOpen(prev => !prev)
      setActiveSubMenu(null)

   }
   //функція для закривання меню при кліку поза меню
   const handleCloseAll = (e) => {
      // console.log('subMenuPopperRef', subMenuPopperRef.current)
      const popperEl = document.querySelector('.MuiPickersPopper-root');
      if (
         e.target.closest('.MuiPickersPopper-root') ||
         subMenuPaperRef.current?.contains(e.target)
      ) {

         return
      }
      setMainOpen(false)
      setActiveSubMenu(null)
      // setSelectedCountrySlug('')
      // setSelectedRegionSlug('')

   }

   const onMainMenuMouseEnter = (key) => {

      setActiveSubMenu(key)

      // setTimeout(() => {
      //    setSubMenuReady(true);
      // }, 0);
   };

   useEffect(() => {
      if (activeSubMenu) {
         setSubMenuReady(false);
         const timer = setTimeout(() => {
            setSubMenuReady(true);
         }, 10);
         return () => clearTimeout(timer);
      } else {
         setSubMenuReady(false);
      }
   }, [activeSubMenu]);

   // console.log('selectedSubItems', selectedSubItems)
   // console.log('items', items)
   // console.log('partnersId', partnersId)
   // console.log('financedId', financedId)
   // console.log('coordinatorId', coordinatorId)
   // console.log('projects', projects)
   // console.log('dateFrom', dateFrom)
   // console.log('dateTo', dateTo)
   // console.log('makeRequest', makeRequest)
   // console.log('activeFilters', activeFilters)

   // if (
   //    !projects ||
   //    projects.length === 0 ||
   //    financedAll.length === 0 ||
   //    partnersAll.length === 0 ||
   //    coordinatorAll.length === 0
   // ) {
   //    return (
   //       <div style={{ padding: '1rem', display: 'flex', justifyContent: 'center' }}>
   //          <CircularProgress size={24} />
   //       </div>
   //    )
   // }



   return (
      <div style={{ order: '2' }}>
         <Button className='dropdown-filter-button'
            ref={anchorRef}
            variant="outlined"
            onClick={handleToggleMain}
         >
            <span>
               <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 10H15M2.5 5H17.5M7.5 15H12.5" stroke="#434349" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
               </svg>
            </span>
            <span className='dropdown-filter-button-text'>Filters</span>
         </Button>

         <Popper
            className='dropdown-custom-popper'
            open={mainOpen}
            anchorEl={anchorRef.current}
            placement="bottom-start"
            // placement='right-end'
            transition
            disablePortal
            modifiers={[
               {
                  name: 'offset',
                  options: {
                     offset: [-100, 10],
                  },
               },
            ]}
         >
            {({ TransitionProps }) => (
               <Grow {...TransitionProps}>
                  <Paper className='dropdown-custom-paper'

                  >

                     <ClickAwayListener onClickAway={handleCloseAll}>

                        {

                           <MenuList autoFocusItem>
                              {items.map(attribute => {

                                 const isMainSelected =
                                    (attribute.slug === 'Visibility' && visibilityFilter === 'visible') ||
                                    (attribute.slug === 'Visibility' && visibilityFilter === 'non_visible') ||
                                    (attribute.slug === 'Date_of_start' && dateFrom && dateTo) ||
                                    selectedSubItems.some(
                                       item => item.slug === attribute.slug
                                    );
                                 // console.log('isMainSelected', isMainSelected)
                                 return <MenuItem
                                    className={`main-dropdown-custom-menu-item ${isMainSelected ? 'selected' : ''}`}
                                    key={attribute.key}
                                    // style={{
                                    //    borderTop: attribute.slug === 'Country' ? '1px solid #eeeef0' : '',

                                    //    borderBottom: attribute.slug === 'Settlement' ? '1px solid #eeeef0' : ''

                                    // }}

                                    ref={attribute.key === activeSubMenu ? subAnchorRef : null}
                                    // onMouseEnter={() => setActiveSubMenu(attribute.key)}
                                    onMouseEnter={() => onMainMenuMouseEnter(attribute.key)}
                                    onMouseLeave={() => {
                                       // activeSubMenu === attribute.key && setActiveSubMenu(null)
                                    }
                                    }
                                 >
                                    {attribute.label}
                                    <span>
                                       <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <g opacity="0.5">
                                             <path d="M6 12L10 8L6 4" stroke="#434349" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                          </g>
                                       </svg>
                                    </span>
                                 </MenuItem>
                              }

                              )}

                              <MenuItem className='main-dropdown-custom-menu-item' onClick={resetAll}>
                                 <span style={{ fontWeight: '700', color: 'black' }}>Reset all</span>
                              </MenuItem>
                           </MenuList>}

                     </ClickAwayListener>
                  </Paper>
               </Grow>
            )}
         </Popper>



         {


            items.map(filter =>
               activeSubMenu === filter.key
                  && subAnchorRef.current
                  ? (
                     <Popper
                        className='sub-dropdown-custom-popper'
                        key={filter.key}
                        open
                        anchorEl={subAnchorRef.current}
                        placement="right-start"
                        // placement='right-end'
                        transition
                        disablePortal
                     // modifiers={[
                     //    {
                     //       name: 'offset',
                     //       options: {
                     //          offset: [0, 140],
                     //       },
                     //    },
                     // ]}
                     >
                        {({ TransitionProps }) => (
                           <Grow {...TransitionProps}>
                              <Paper
                                 className='sub-dropdown-custom-papper'
                                 onMouseEnter={() => setActiveSubMenu(filter.key)}
                                 onMouseLeave={() => {
                                    // setActiveSubMenu(null)
                                 }}
                                 ref={subMenuPaperRef}
                              >

                                 {/* <div className='sub-dropdown-custom-paper-inner'> */}
                                 {filter.slug !== 'Date_of_start' &&


                                    <MenuList className='sub-dropdown-custom-menu' autoFocusItem>

                                       {filter.options.length > 0 && <MenuItem
                                          key={`clean-item ${filter.key}`}
                                          className='sub-dropdown-custom-menu-item'
                                          onClick={() => cleanListItem(filter?.slug)}
                                       >
                                          {filter.slug === 'Status' &&
                                             <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clipPath="url(#clip0)">
                                                   <circle cx="10" cy="10" r="8.25" stroke="#434349" strokeWidth="1.5" />
                                                   <line x1="6.5" y1="10" x2="13.5" y2="10" stroke="#434349" strokeWidth="1.5" strokeLinecap="round" />
                                                </g>
                                                <defs>
                                                   <clipPath id="clip0">
                                                      <rect width="20" height="20" fill="white" />
                                                   </clipPath>
                                                </defs>
                                             </svg>

                                          }
                                          <span
                                             // style={{ marginLeft: '10px' }}
                                             style={{ marginLeft: filter.slug === 'Status' && '10px' }}
                                          >not set</span>
                                       </MenuItem>}

                                       {filter.options.map(option => {

                                          const isSelected =
                                             (option.slug === 'Visibility' && option.id === visibilityFilter) ||

                                             selectedSubItems.some(
                                                item => item.slug === filter.slug && item.id === option.id
                                             );


                                          return (
                                             <MenuItem
                                                key={`${option.id} ${filter.slug}`}
                                                className={`sub-dropdown-custom-menu-item ${isSelected ? 'selected' : ''}`}
                                                onClick={() => {
                                                   // console.log('clickedOption', option)
                                                   handleActiveFilters(filter.slug, filter.label, option.slug, option.name, option.id)
                                                   if (option.slug === 'Visibility') {

                                                      setVisibilityFilter(option.id);
                                                      return
                                                   }

                                                   else if (filter.slug === 'Projects') {

                                                      setProjectsId(option.id)
                                                      handleSubItem(option.id, filter.slug)
                                                      return
                                                   }
                                                   else if (filter.slug === 'Status') {
                                                      setProjectsStatus(option.slug)
                                                      handleSubItem(option.id, filter.slug)
                                                      return
                                                   }

                                                   else if (filter.slug === 'Financed') {
                                                      setFinancedId(option.id)
                                                      handleSubItem(option.id, filter.slug)
                                                      return
                                                   }
                                                   else if (filter.slug === 'Partners') {
                                                      setPartnersId(option.id)
                                                      handleSubItem(option.id, filter.slug)
                                                      return
                                                   }
                                                   else if (filter.slug === 'Coordinator') {
                                                      setCoordinatorId(option.id)
                                                      handleSubItem(option.id, filter.slug)
                                                      return
                                                   }


                                                   // else {
                                                   //    handleSubItem(option.id, filter.slug)
                                                   // }
                                                }
                                                }
                                             >
                                                {(filter.slug === 'Status' && option.icon) && option.icon}  {filter.slug !== 'Projects' ? <span
                                                   // style={{ marginLeft: '10px' }}
                                                   style={{ marginLeft: filter.slug === 'Status' && '10px' }}
                                                >{option.name}</span> : <span
                                                   //  style={{ marginLeft: '10px' }}
                                                   style={{ marginLeft: filter.slug === 'Status' && '10px' }}
                                                >{option.id}</span>}
                                             </MenuItem>
                                          );
                                       })}


                                    </MenuList>}
                                 {
                                    filter.slug === 'Date_of_start' &&

                                    <MenuList className='sub-dropdown-custom-menu' autoFocusItem>
                                       <LocalizationProvider
                                          dateAdapter={AdapterDayjs}
                                       >
                                          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                                             <MenuItem
                                                className='sub-dropdown-custom-menu-item'
                                                onClick={() => {
                                                   setDateFrom(null)
                                                   setDateTo(null)
                                                   setMakeRequest(true)
                                                   // cleanListItem(filter?.slug)
                                                }}
                                             >
                                                clean dates
                                             </MenuItem>
                                             <MenuItem
                                                // key={`clean-item ${filter.key}`}
                                                className='sub-dropdown-custom-menu-item'
                                             // onClick={() => cleanListItem(filter?.slug)}
                                             >
                                                <DatePicker
                                                   label="Date_from"
                                                   value={dateFrom}
                                                   onChange={(newValue) => setDateFrom(newValue)}
                                                   format="YYYY-MM-DD"
                                                   maxDate={dateTo ?? undefined}
                                                   slotProps={{
                                                      textField: {
                                                         size: 'small',
                                                         fullWidth: true,
                                                         variant: 'standard',
                                                      },
                                                   }}
                                                />
                                             </MenuItem>
                                             <MenuItem
                                                // key={`clean-item ${filter.key}`}
                                                className='sub-dropdown-custom-menu-item'
                                             // onClick={() => cleanListItem(filter?.slug)}
                                             >

                                                <DatePicker
                                                   label="Date_to"
                                                   value={dateTo}
                                                   onChange={(newValue) => setDateTo(newValue)}
                                                   format="YYYY-MM-DD"
                                                   minDate={dateFrom ?? undefined}
                                                   slotProps={{
                                                      textField: {
                                                         size: 'small',
                                                         fullWidth: true,
                                                         variant: 'standard',
                                                      },
                                                   }}
                                                />
                                             </MenuItem>
                                          </div>
                                       </LocalizationProvider>
                                    </MenuList>
                                 }

                                 {/* </div> */}

                              </Paper>
                           </Grow>
                        )}
                     </Popper>
                  ) : null
            )
         }


      </div>
   )
}